// extracted by mini-css-extract-plugin
export default {"benefitsSection":"BenefitsSection_benefitsSection__rK2ep","container":"BenefitsSection_container__txlX-","content":"BenefitsSection_content__b2JYG"};